/**
 * Extensibility point for zone-based scenery rendering.
 * Reads ScenerySetup from store and maps zones to type-specific components.
 * Currently no zone renderers are implemented — all fall through to null.
 * Future zone types (gas clouds, debris fields, nebula patches) add cases here.
 */

import {
  SCENERY_ZONE_GAS_CLOUD,
  SCENERY_ZONE_DEBRIS_FIELD,
  SCENERY_ZONE_NEBULA_PATCH,
} from '@warmancer/shared';
import type { SceneryZone } from '@warmancer/shared';
import { useGameStore } from '../../stores/gameStore.js';

function renderZone(zone: SceneryZone): React.ReactNode {
  switch (zone.type) {
    case SCENERY_ZONE_GAS_CLOUD:
    case SCENERY_ZONE_DEBRIS_FIELD:
    case SCENERY_ZONE_NEBULA_PATCH:
    default:
      return null;
  }
}

export function SceneryRenderer() {
  const scenerySetup = useGameStore((s) => s.scenerySetup);

  if (!scenerySetup || scenerySetup.zones.length === 0) {
    return null;
  }

  return (
    <group>
      {scenerySetup.zones.map((zone) => renderZone(zone))}
    </group>
  );
}
